export default "__VITE_ASSET__C4UMHCF5__"